import React from "react";
import Hamper from '../../assests/images/Hamper.png'

const SecondSectionServices = () => {
  return (
    <section className="w-full px-6 md:px-12 lg:px-20">
      <div className="mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

        {/* LEFT CONTENT */}
        <div>
          

          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            NextLoop{" "}
            <span className="text-[#92abc4]">Services</span>
          </h1>

          <p className="text-gray-500 leading-relaxed mb-6 max-w-xl">
            NextLoop Services provides comprehensive corporate solutions tailored to meet the diverse needs of businesses. Our expertise spans integrated corporate services, office management solutions, event planning, lifestyle coordination, and end-to-end product manufacturing. Whether it’s streamlining operations, executing seamless corporate events, or delivering high-quality products, NextLoop is committed to creating value, efficiency, and excellence for our clients.
          </p>

          <p className="text-gray-500 leading-relaxed mb-8 max-w-xl">
            Our team manages the entire process — from concept and design to
            production and delivery — ensuring consistent quality and
            brand-aligned results every time.
          </p>

          {/* CATEGORIES */}
          {/* <div className="space-y-3 max-w-sm">
            {["Custom Hampers", "Corporate Gifts", "Awards & Merchandise"].map(
              (item) => (
                <div key={item} className="flex items-center gap-4">
                  <div className="h-px w-10 bg-gray-300" />
                  <span className="text-sm text-gray-600 uppercase tracking-wide">
                    {item}
                  </span>
                </div>
              )
            )}
          </div> */}
        </div>

        {/* RIGHT IMAGE */}
       <div className="relative">
  <img
  src={Hamper}
  alt="Custom corporate products"
  className="w-3/4 h-auto object-cover mx-auto md:mx-0"
 />

  {/* FLOATING CARD */}
  <div
    className="
      bg-sky-400 text-white p-6 md:p-8 w-full md:w-72
      mt-6 md:mt-0
      md:absolute md:top-8 md:right-8
      shadow-lg
    "
  >
    <h3 className="font-bold text-lg mb-2 uppercase">
      Target Clients
    </h3>
    <p className="text-sm leading-relaxed text-white/90">
      Corporations, event organizers, schools, and brands seeking
      premium, customizable physical goods for gifting, recognition,
      promotions, and events.
    </p>
  </div>
</div>


      </div>
    </section>
  );
};

export default SecondSectionServices;
